{
	"title": "Nova",
	"subtitle": "Assistant · answers from what you can see in GMS",
	"open": "Ask Nova",
	"close": "Close Nova",
	"newChat": "New chat",
	"placeholder": "Ask Nova…",
	"send": "Send",
	"thinking": "Looking it up…",
	"you": "You",
	"assistant": "Nova",
	"empty": "Ask about your records, competition results or medals.",
	"records": {
		"heading_one": "{{count}} record",
		"heading_other": "{{count}} records",
		"shown": "Showing {{shown}} of {{total}}",
		"noPhoto": "No photo",
		"openAll": "Open the full list",
		"empty": "No records match.",
		"meta": "{{number}} · {{organization}} · {{category}}"
	},
	"status": {
		"DRAFT": "Draft",
		"SUBMITTED": "Submitted",
		"PENDING": "Pending",
		"APPROVED": "Approved",
		"RETURN": "Returned",
		"REJECTED": "Rejected",
		"WITHDRAWN": "Withdrawn"
	},
	"recordsLink_one": "Open this record",
	"recordsLink_other": "Open these {{count}} records",
	"guide": {
		"start": "Start here"
	},
	"notion": {
		"heading": "From WSL Notion"
	},
	"report": {
		"records_one": "{{count}} record",
		"records_other": "{{count}} records",
		"download": "Download PDF",
		"preparing": "Preparing…"
	},
	"limitNote": "Nova can make mistakes. Check important numbers in GMS.",
	"unavailable": "Nova is unavailable right now. Please try again in a moment."
}
